import React from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index'
import routes from '../routes'

const DefaultLayout = () => {
  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-main">
        <AppHeader />
        <div className="body flex-grow-1 px-0">
          <AppContent routes={routes} />
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

export default DefaultLayout
